module.exports = __webpack_public_path__ + "media/images/application/avatar-01c29d403b0d95ced01c8cb4cf7229e8.png";